export default "__VITE_ASSET__DgHnQt4m__"